import AlertCore from '../../Core/Components/_textBlockComponents/Alert'

export const Alert = AlertCore
